<div
  TsFieldStyling
  [fieldBackgroundColor]="fieldStyling().color"
  [fieldBold]="fieldStyling().is_bold"
  [targetStylingClass]="commonTargetStylingClass"
  class="flex-auto gt-xs:pr-3 w-full mb-2"
>
  @if (fieldDef.name === 'address_string') {
    <ts-input
      [label]="fieldDef.label"
      [testId]="'form-field-' + fieldDef.name"
      placeholder="Enter a location"
      [maxlength]="1024"
      [mask]="mask$ | async"
      [formControl]="control"
      [dataCy]="'form-panel-text-form-field'"
      google-place
      [manualAttach]="true"
      (onSelectParts)="onSetAddress($event)"
      (click)="edit()"
      (keyup.enter)="$event.preventDefault()"
    ></ts-input>
  } @else {
    <ts-input
      [label]="fieldDef.label"
      [testId]="'form-field-' + fieldDef.name"
      [maxlength]="1024"
      [mask]="mask$ | async"
      [formControl]="control"
      [dataCy]="'form-panel-text-form-field'"
      (click)="edit()"
      (keyup.enter)="onBlur()"
      (blur)="onBlur()"
    ></ts-input>
  }
</div>
